import { Box, IconButton, useTheme } from "@mui/material";

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import BaseCard from "../../../theme/cards/BaseCard";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import Text from "../../../theme/text/Text";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { getWarehouseLocationLabelData } from "../../../../utils/labelColorText";
const WarehouseCard = (props) => {
    const {t} = useTranslation();

    return (
        <BaseCard onClick={props.onClick}>
            <Box>
                <Box>
                    <Box>
                        <Text bold>{props.name}</Text>
                    </Box>

                    {/* Holds tht date and batch */}
                    <Box marginTop={2}>

                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            {props.skeleton ?
                                <ShDoubleTextSkeleton/> 
                                :
                                <>
                                    <Text>
                                        {props.street} {props.house_nr}{props.house_nr_extra}
                                    </Text>
                                    <Text>
                                         {props.postal} {props.city}
                                    </Text>
                                </>
                            }
                        </Box>
                    </Box>
                </Box>
            </Box>
        </BaseCard>
    )
}

export default WarehouseCard;

export const WarehouseZoneCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <BaseCard onClick={props.onClick ?? null}>
            <Box>
                <Box>
                    <Box>
                        <Text bold>{props.description}</Text>
                    </Box>

                    {props.hasModifyPermission && 
                        <TopRight>
                            <CardLabel 
                                onClick={props.setWarehouseZoneInfo}
                                variant={theme.palette.mode === "dark" ? "greyLight" : "grey"}
                                hasright 
                                fitted
                                colorflip={theme.palette.mode !== "dark"}
                                position="child-tr"
                            >
                                {t("edit")}
                            </CardLabel>
                            <CardLabel 
                                hasleft 
                                variant={"red"} 
                                position="child-tr"
                                onClick={props.handleDeleteWarehouseZone}
                            >
                                {t("delete")}
                            </CardLabel>
                        </TopRight>
                    }
                    {/* Holds tht date and batch */}
                    <Box 
                        sx={{
                            mt:2,
                            display:"flex",
                            gap:3,
                        }}
                    >

                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("multiproduct")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/> 
                                :
                                props.multiproduct ?
                                <CheckIcon 
                                    sx={{
                                        color:colors.green[400]
                                    }}
                                /> 
                                :
                                <CloseIcon
                                    sx={{
                                        color:colors.red[400]
                                    }}
                                />

                            }
                        </Box>
                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("multibatch")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/> 
                                :
                                props.multibatch ?
                                <CheckIcon 
                                    sx={{
                                        color:colors.green[400]
                                    }}
                                /> 
                                :
                                <CloseIcon
                                    sx={{
                                        color:colors.red[400]
                                    }}
                                />

                            }
                        </Box>
                    </Box>
                </Box>
            </Box>
        </BaseCard>
    )
}


export const WarehouseLevelCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            sx={{
                display:"flex",
            }}
        >
            <BaseCard onClick={props.onClick ?? null}>
                <Box>
                    <Box>
                        <Box>
                            <Text bold>{props.description}</Text>
                        </Box>

                        {props.hasModifyPermission && 
                            <TopRight>
                                <CardLabel 
                                    onClick={props.setWarehouseLevelInfo}
                                    variant={theme.palette.mode === "dark" ? "greyLight" : "grey"}
                                    hasright 
                                    fitted
                                    colorflip={theme.palette.mode !== "dark"}
                                    position="child-tr"
                                >
                                    {t("edit")}
                                </CardLabel>
                                <CardLabel 
                                    hasleft 
                                    variant={"red"} 
                                    position="child-tr"
                                    onClick={props.handleDeleteWarehouseLevel}
                                >
                                    {t("delete")}
                                </CardLabel>
                            </TopRight>
                        }
                        {/* Holds tht date and batch */}
                        <Box 
                            sx={{
                                mt:2,
                                display:"flex",
                                gap:3,
                            }}
                        >

                            <Box
                                sx={{
                                    display:'flex',
                                    flexDirection:"column"
                                }}
                            >
                                <Text light>{t("level")}</Text>
                                {props.skeleton ?
                                    <ShTextSkeleton/> 
                                    :
                                    <Text>{props.index}</Text>

                                }
                            </Box>
                         
                        </Box>
                    </Box>
                </Box>
            </BaseCard>
            {props.hasModifyPermission &&
                <Box
                    sx={{
                        display:"flex",
                        flexDirection:"column",
                    }}
                >
                    { props.index > 1 ? 
                        <IconButton
                            type="button" 
                            onClick={props.handleDown}
                            sx={{
                                transform: 'rotate(270deg)',
                                color:colors.primary[400]
                            }}
                        >
                            <ArrowRightAltIcon/>
                        </IconButton> 
                    : 
                        <Box sx={{width:32}}></Box>
                    }
                    { !props.isMax ? 
                        <IconButton 
                            type="button" 
                            onClick={props.handleUp}
                            sx={{
                                mt:"auto",
                                transform: 'rotate(90deg)',
                                color:colors.txt["primary"]
                            }}
                        >
                            <ArrowRightAltIcon/>
                        </IconButton> 
                    : 
                        <Box sx={{width:40,height:32,display:"block"}}></Box>
                    }
                </Box>
            }
        </Box>
    )
}

export const WarehouseIndexCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            sx={{
                display:"flex",
            }}
        >
            <BaseCard onClick={props.onClick ?? null}>
                <Box>
                    <Box>
                        <Box>
                            <Text bold>{props.name}</Text>
                        </Box>

                        
                        {/* Holds tht date and batch */}
                        <Box 
                            sx={{
                                mt:2,
                                display:"flex",
                                gap:3,
                            }}
                        >

                            <Box
                                sx={{
                                    display:'flex',
                                    flexDirection:"column"
                                }}
                            >
                                <Text light>{t("level")}</Text>
                                {props.skeleton ?
                                    <ShTextSkeleton/> 
                                    :
                                    <Text>{props.index}</Text>

                                }
                            </Box>
                         
                        </Box>
                    </Box>
                </Box>
            </BaseCard>
            {props.hasModifyPermission &&
                <Box
                    sx={{
                        display:"flex",
                        flexDirection:"column",
                    }}
                >
                    { props.index > 1 ? 
                        <IconButton
                            type="button" 
                            onClick={props.handleDown}
                            sx={{
                                transform: 'rotate(270deg)',
                                color:colors.primary[400]
                            }}
                        >
                            <ArrowRightAltIcon/>
                        </IconButton> 
                    : 
                        <Box sx={{width:32}}></Box>
                    }
                    { !props.isMax ? 
                        <IconButton 
                            type="button" 
                            onClick={props.handleUp}
                            sx={{
                                mt:"auto",
                                transform: 'rotate(90deg)',
                                color:colors.txt["primary"]
                            }}
                        >
                            <ArrowRightAltIcon/>
                        </IconButton> 
                    : 
                        <Box sx={{width:40,height:32,display:"block"}}></Box>
                    }
                </Box>
            }
        </Box>
    )
}

export const WarehouseLocationTypeCard = (props) => {
    const theme = useTheme();
    const { t,i18n } = useTranslation();
    const { labelcolor, labeltext } = getWarehouseLocationLabelData(props.type, theme);
   
    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    <Box
                        sx={{
                            display:"flex",
                            flexDirection:"column"
                        }}
                    >
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <Text bold>{props.description}</Text>
                        }
                    </Box>
                    <Box 
                        sx={{
                            mt:2,
                            display:"flex",
                            gap:3,
                        }}
                    >
                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("dimensions_lwh")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/> 
                                :
                                <>
                                    <Text>
                                        {`${props.length}mm x ${props.width}mm x ${props.height}mm`}
                                    </Text>
                                </>
                            }
                        </Box>

                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("max_weight")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/> 
                                :
                                <>
                                    <Text>
                                        {props.maxWeight} kg
                                    </Text>
                                </>
                            }
                        </Box>
                    </Box>

                    <TopRight>
                        <CardLabel hasleft fitted variant={labelcolor} position="child-tr">
                            {t(labeltext)}
                        </CardLabel>
                    </TopRight>
                </Box>
            </Box>
        </BaseCard>

    )
}

export const WarehouseReachTypeCard = (props) => {
    const theme = useTheme();
    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    <Box
                        sx={{
                            display:"flex",
                            flexDirection:"column"
                        }}
                    >
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <Text bold>{props.description}</Text>
                        }
                    </Box>
                </Box>
            </Box>
        </BaseCard>
    )
}